import { permissionsStructureSchema } from '../model/form-permissions.store';
import type { FormElement } from '../model/form.types';
import { iterateFormElements } from './form-element-traversal';

export const UNRECOGNIZED_PERMISSIONS_MESSAGE =
  'As permissões desta matriz estão num formato que o construtor não reconhece. Configure as permissões novamente.';

export function emptyGrantMessage(fieldLabels: string[]): string {
  return `Há permissão sem cargo e sem atividade funcional nos campos: ${fieldLabels.join(', ')}. Escolha ao menos um cargo ou uma atividade, ou limpe a permissão do campo.`;
}

export function fieldLabel(element: FormElement | undefined, fieldId: string): string {
  const label = element?.properties.label?.trim();
  if (label) return label;
  const name = element?.properties.name?.trim();
  return name ? name : fieldId;
}

/**
 * The message that stops a save or a send, or null. The engine reads a grant with no position and
 * no activity as "nobody", and the server refuses it, so the builder names the fields first.
 */
export function findPermissionsSubmitProblem(
  permissionsStructure: object | null,
  elements: readonly FormElement[]
): string | null {
  if (permissionsStructure === null) return null;

  const parsed = permissionsStructureSchema.safeParse(permissionsStructure);
  if (!parsed.success) return UNRECOGNIZED_PERMISSIONS_MESSAGE;

  const emptyFieldIds = [
    ...new Set(
      parsed.data.fields
        .filter((grant) => grant.positionIds.length === 0 && grant.functionalActivityIds.length === 0)
        .map((grant) => grant.fieldId)
    ),
  ];
  if (emptyFieldIds.length === 0) return null;

  const elementsById = new Map(
    [...iterateFormElements(elements, { includeTableContainers: true })].map((element) => [
      element.id,
      element,
    ])
  );
  return emptyGrantMessage(emptyFieldIds.map((fieldId) => fieldLabel(elementsById.get(fieldId), fieldId)));
}
